import React from 'react'
import AppView from './AppView'
import './AppView.css'
import * as apiClient from '../../common/ApiClient/ApiClient'

class App extends React.Component {

    componentDidMount() {
        apiClient.init({ onReady: () => this.apiClientLoaded() })
    }

    componentDidUpdate(prevProps) {
        if (this.props.path !== prevProps.path) {
            this.props.dismissFlashMessage()
        }
    }

    apiClientLoaded() {
        this.props.apiClientLoaded(true)
    }

    render() {
        return (
            <AppView path={this.props.path}/>
        )
    }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App/App.jsx